import React from "react";
import { useUpdateEffect } from "react-use";

import { useScoped } from "~/tools/impulse";
import { useHandler } from "~/tools/use-handler";

import { TimelineSummaryRequestContext } from "./_timeline-summary-request-context";

export interface UseOnTimelineSummaryRequestRefreshOptions {
	enabled?: boolean;
}

export const useOnTimelineSummaryUpdate = (
	callback: (refreshCount: number) => void,
	{ enabled = true }: UseOnTimelineSummaryRequestRefreshOptions = {},
): void => {
	const context = React.useContext(TimelineSummaryRequestContext);
	const stableCallback = useHandler(callback);
	const refreshCount = useScoped(
		(scope) => (enabled ? context?.getValue(scope).refreshCount : undefined),
		[context, enabled],
	);

	useUpdateEffect(() => {
		if (refreshCount != null) {
			stableCallback(refreshCount);
		}
	}, [refreshCount, stableCallback]);
};
